import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { loadRestaurantsAsync, switchToEditMode, switchToViewMode, saveRestaurantsAsync, searchRestaurantsAsync } from '../../../../actions/poolRestaurants'
import React from 'react'
import RestaurantTable from './restaurantTable'
import './styles.css'

import Loader from '../../../../components/loader'
import PropTypes from 'prop-types'
import { canEditPoolRestaurantsForTenant, isMagicEnabledFromSearch } from '../../../../helpers/tenant'

export const RESTAURANT_DISPLAY_MODE = Object.freeze({
  VIEW: Symbol("View"),
  EDIT: Symbol("Edit"),
  ADD: Symbol("Add")
})

export class Restaurants extends React.Component {

  constructor(props) {
    super(props)
    this.state = { searchTextValue: '' }
  }

  componentDidMount() {
    this.props.switchToViewMode()
    this.props.loadRestaurantsAsync({
      id: this.props.id
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page || prevProps.id !== this.props.id || prevProps.tenant !== this.props.tenant || prevProps.isMagicEnabled !== this.props.isMagicEnabled) {
      this.props.switchToViewMode()
      this.props.loadRestaurantsAsync({
        id: this.props.id
      })
    }
  }

  onChange(event) {
    this.setState({ searchTextValue: event.target.value })
  }

  getPoolSubscriptionName(isInEditMode) {
    let restaurants = isInEditMode ? this.props.poolRestaurantsInEdit : this.props.poolRestaurants

    if (!restaurants || restaurants.length === 0) return ""

    const groupedBySubscriptionName = restaurants.reduce(function (accumulatedBySubscriptionName, restaurant) {
      if (restaurant.partnerSubscriptions && restaurant.partnerSubscriptions.length > 0) {
        const subscriptionName = restaurant.partnerSubscriptions[0].name
        accumulatedBySubscriptionName[subscriptionName] = accumulatedBySubscriptionName[subscriptionName] || 0
        accumulatedBySubscriptionName[subscriptionName]++
      }
      return accumulatedBySubscriptionName
    }, Object.create(null))

    const mostUsedSubscription = Object.keys(groupedBySubscriptionName)
      .map((key) => { return { subscriptionName: key, used: groupedBySubscriptionName[key] } })
      .sort((a, b) => b.used - a.used)[0]

    return mostUsedSubscription ? mostUsedSubscription.subscriptionName : ""
  }

  render() {

    const { poolId, poolRestaurantsIsLoading, poolRestaurants,
      poolRestaurantsInEdit, restaurantsList, restaurantsListIsLoading,
      switchToViewMode, switchToEditMode, saveRestaurantsAsync, searchRestaurantsAsync } = this.props

    let actionMenu = null
    let tableView = null

    const poolSubscriptionName = this.getPoolSubscriptionName(this.props.restaurantDisplayEditMode)
    const canEditRestaurants = canEditPoolRestaurantsForTenant(this.props.tenant, this.props.isMagicEnabled)
    const editRestaurantsTooltip = canEditRestaurants
      ? ''
      : 'Function disabled for legacy Takeaway countries.'
    const editRestaurantsClassName = canEditRestaurants ? '' : 'legacy-disabled-action'

    if (this.props.restaurantDisplayEditMode) {
      actionMenu =
        <div className="float-right">
          <button id="btnCancel" onClick={switchToViewMode} className="btn btn-sm btn-secondary mr-1">Cancel</button>
          <button id="btnSave" onClick={() => saveRestaurantsAsync(poolId, poolRestaurantsInEdit)} className="btn btn-sm btn-success">Save</button>
        </div>

      let searchResults = <div className="alert alert-info">No Search Results</div>
      if (restaurantsList.length > 0) {
        searchResults = <RestaurantTable id="searchResultsTable" poolSubscriptionName={poolSubscriptionName} restaurants={restaurantsList} restaurantDisplayAction={RESTAURANT_DISPLAY_MODE.ADD} />
      }

      tableView =
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="row editRow">
              <div className="col-lg-6 col-sm-12">
                <h4 className="pull-left">In Pool</h4>
              </div>
            </div>
            <RestaurantTable id="inPoolTable" poolSubscriptionName={poolSubscriptionName} restaurants={poolRestaurantsInEdit} restaurantDisplayAction={RESTAURANT_DISPLAY_MODE.EDIT} />
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="row editRow">
              <div className="col-lg-5 col-sm-12">
                <h4 >Search</h4>
              </div>
              <div className="col-lg-7 col-sm-12">
                <div className="input-group mb-3">
                  <input id="searchText" type="text" className="form-control form-control-sm" onChange={this.onChange.bind(this)}
                    onKeyPress={(e) => e.key === 'Enter' ? searchRestaurantsAsync(this.state.searchTextValue, 0) : null}
                    placeholder="Restaurant Search by Name" />
                  <div className="input-group-append">
                    <button id="btnSearch" onClick={() => searchRestaurantsAsync(this.state.searchTextValue, 0)} className="btn btn-sm btn-primary">Go</button>
                  </div>
                </div>
              </div>
            </div>
            {restaurantsListIsLoading ? <Loader /> : searchResults}
          </div>
        </div>
    }
    else {
      actionMenu =
        <div className="float-right">
          <span title={editRestaurantsTooltip}>
            <button id="switchMode" className={`btn btn-sm btn-primary ${editRestaurantsClassName}`.trim()} disabled={!canEditRestaurants || restaurantsListIsLoading || poolRestaurantsIsLoading} onClick={() => { switchToEditMode(poolRestaurants) }}>Edit Restaurants</button>
          </span>
        </div>

      tableView = poolRestaurantsIsLoading
        ? <Loader />
        : <RestaurantTable id="currentRestaurantsTable" poolSubscriptionName={poolSubscriptionName} restaurants={poolRestaurants} restaurantDisplayAction={RESTAURANT_DISPLAY_MODE.VIEW} />
    }

    return <div>
      <div className="row switchMode">
        <div className="col-lg-5 col-sm-12">
          <h3 className="pull-left">Restaurants</h3>
        </div>
        {actionMenu}
      </div>
      {tableView}
    </div>
  }
}

Restaurants.propTypes = {
  // navigation / identity
  id: PropTypes.string,
  poolId: PropTypes.string,
  page: PropTypes.number,
  // data collections
  poolRestaurants: PropTypes.arrayOf(PropTypes.object),
  poolRestaurantsInEdit: PropTypes.arrayOf(PropTypes.object),
  restaurantsList: PropTypes.arrayOf(PropTypes.object),
  // loading flags
  poolRestaurantsIsLoading: PropTypes.bool,
  restaurantsListIsLoading: PropTypes.bool,
  restaurantDisplayEditMode: PropTypes.bool,
  tenant: PropTypes.string,
  isMagicEnabled: PropTypes.bool,
  // actions
  switchToViewMode: PropTypes.func.isRequired,
  loadRestaurantsAsync: PropTypes.func.isRequired,
  switchToEditMode: PropTypes.func.isRequired,
  saveRestaurantsAsync: PropTypes.func.isRequired,
  searchRestaurantsAsync: PropTypes.func.isRequired
}

const mapStateToProps = (state, props) => {
  return {
    poolId: props.id,
    poolRestaurants: state.poolDetails.restaurants.data,
    poolRestaurantsIsLoading: state.poolDetails.isLoading,
    poolRestaurantsInEdit: state.restaurantsEdit.restaurantsInPool,
    restaurantsList: state.restaurantsEdit.foundRestaurants.data,
    restaurantsListIsLoading: state.restaurantsEdit.isLoading,
    restaurantDisplayEditMode: state.restaurantsEdit.restaurantDisplayEditMode,
    tenant: state.system && state.system.tenant,
    isMagicEnabled: isMagicEnabledFromSearch(state.router && state.router.location && state.router.location.search)
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadRestaurantsAsync,
  switchToEditMode,
  switchToViewMode,
  saveRestaurantsAsync,
  searchRestaurantsAsync
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Restaurants)




// WEBPACK FOOTER //
// ./src/containers/pools/details/restaurants/index.js